import { EmptyGrowPanelText } from "styles/text";
import { Panel } from "components/Panel/Panel";
import { Match } from "model/Match/Match";
import { MatchViewerTeams } from "./Teams/MatchViewerTeams";
import { MatchSetSwitcher } from "./SetSwitcher/MatchSetSwitcher";
import { matchSetHasData } from "model/Match/Set/MatchSet";
import { MatchSetViewer } from "./MatchSetViewer";

interface Props {
  match: Match;
  tournamentId: string;
  selectedSetIdx: number | undefined;
  setSelectedSetIdx: React.Dispatch<React.SetStateAction<number | undefined>>;
}

export const MatchViewer = ({
  match,
  tournamentId,
  selectedSetIdx,
  setSelectedSetIdx,
}: Props) => {
  return (
    <>
      {match.sets?.at(0)?.type !== "TimeAttack" && (
        <MatchViewerTeams match={match} tournamentId={tournamentId} />
      )}

      {match.isDelayed && (
        <Panel>
          <EmptyGrowPanelText>This Match Has Been Delayed</EmptyGrowPanelText>
        </Panel>
      )}

      {match.sets.some(
        (s) => matchSetHasData(s) || s.type === "TimeAttack"
      ) && (
        <>
          {match.format.type !== "Single" && (
            <Panel padding="padded">
              <MatchSetSwitcher
                sets={match.sets}
                teams={match.teams}
                tournamentId={tournamentId}
                setAdvantageRosterIds={match.format.setAdvantageRosterIds ?? []}
                selectedSetIdx={selectedSetIdx}
                setSelectedSetIdx={setSelectedSetIdx}
              />
            </Panel>
          )}
          {selectedSetIdx !== undefined && (
            <MatchSetViewer
              matchId={match.id}
              tournamentId={tournamentId}
              set={match.sets[selectedSetIdx]}
              teams={match.teams}
            />
          )}
        </>
      )}
    </>
  );
};
